var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.79316 4.28373C9.23125 4.27666 8.67086 4.34391 8.12657 4.48372C5.69928 5.09183 3.35791 6.98878 1.77799 8.92054C1.5726 9.18165 1.46094 9.50422 1.46094 9.83642C1.46094 10.1686 1.5726 10.4912 1.77799 10.7523C3.33347 12.6515 5.66891 14.5818 8.12953 15.1965C8.67304 15.3349 9.23236 15.4014 9.79316 15.3943C10.355 15.4016 10.9153 15.3352 11.4597 15.1965C13.9204 14.584 16.258 12.653 17.8106 10.7523C18.0159 10.4912 18.1276 10.1686 18.1276 9.83642C18.1276 9.50422 18.0159 9.18165 17.8106 8.92054C16.2299 6.98804 13.8848 5.09109 11.4597 4.48297C10.9154 4.34354 10.355 4.27654 9.79316 4.28373V4.28373Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 431",
    cx: 9.79088,
    cy: 9.63072,
    rx: 1.619,
    ry: 1.619,
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassEyeOpen);
export default __webpack_public_path__ + "static/media/passEyeOpen.5a9667eb408104003dcf94f181aa440b.svg";
export { ForwardRef as ReactComponent };